import React, { Component } from 'react';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { BarChart, MediumBarChart } from '../../components/bar-chart/';
import styles from './chart-area.module.scss';
import * as selectors from '../../reducers';
import { humanizeNumber } from '../../helpers/formatters';
import { entityLabelMatcher } from "../../helpers/label-mapper";

class ChartArea extends Component {
    constructor() {
        super();
        this.chartMapper = this.chartMapper.bind(this);
    }

    getLegendPhrase(chartData) {
        const { activeCouncil } = this.props;
        const area = activeCouncil[chartData.area];
        return area;
    }

    renderTrend(trend) {
        if (!trend) {
            return null;
        }

        const color = '#9a8273';
        return (
            <span
                style={{
                    color,
                    marginRight: 10,
                }}
            >
                {trend === '−' ? 'No Trend' : `Trend ${trend}`}
            </span>
        );
    }
    isTextBarChart(data) {
        return data.max === 'High';
    }

    // not the nicest, I'm sorry.
    getAdditionalChartText(title) {
        switch (title) {
            case 'Operating Surplus Ratio': {
                return 'The state government’s target for the council is between 0 and 10 per cent.';
            }
            case 'Net Financial Liabilities': {
                return 'The state government’s target for the council is less than 60 per cent.';
            }
            case 'Asset Sustainability Ratio': {
                return 'The state government’s target for the council is greater than 90 per cent.';
            }
            default: {
                return null;
            }
        }
    }

    chartMapper(chartData, index) {
        const {
            color,
            unit,
            activeCouncil,
            comparedCouncil,
            title,
            councils,
            visible,
            trend,
        } = this.props;

        switch (chartData.type) {
            case 'main':
                return (
                    <BarChart
                        key={index}
                        data={chartData}
                        color={color}
                        unit={unit}
                        tickIsHidden={activeCouncil.isBlank || activeCouncil.entityCategory.includes("Other Institutions")}
                        visible={visible}
                        isStatic={activeCouncil.entityCategory.includes("Other Institutions")}
                    >
                        {this.renderTrend(trend)}
                        {activeCouncil.entityCategory.includes("Other Institutions") ? "" : activeCouncil.name}
                    </BarChart>
                );
            case 'compared':
                return (
                    <BarChart
                        key={index}
                        data={chartData}
                        color={color}
                        unit={unit}
                        tickIsHidden={comparedCouncil.isBlank}
                        visible={visible}
                    >
                        {this.renderTrend(trend)}

                        {comparedCouncil.name}
                    </BarChart>
                );
            case 'median':
                const medianCount = councils.filter(
                    council =>
                        council[chartData.area] === activeCouncil[chartData.area] &&
                        !council.isBlank
                );
                if (chartData.max === 'High' || activeCouncil.entityCategory.includes("Other Institutions")) {
                    // No median for text bar chart or institutions
                    return <div></div>;
                }
                return (
                    <MediumBarChart
                        key={index}
                        data={chartData}
                        color={color}
                        unit={unit}
                        visible={visible}
                    >
                        <div className={styles.chartLegend}>
                            Median of {medianCount ? medianCount.length : 0}{' '}
                            <span className={styles.chartLegendBold}>
                                {this.getLegendPhrase(chartData)}
                            </span>
                        </div>
                    </MediumBarChart>
                );
            case 'text':
                const additionalText = this.getAdditionalChartText(title);
                return (
                    activeCouncil.entityCategory.includes("Other Institutions") ?
                        <div></div> :
                        <div key={index} className={styles.chartBottomText}>
                            <span>{title}</span> reported for Queensland {entityLabelMatcher(activeCouncil.entityCategory, 'plural').toLocaleLowerCase()} ranged from{' '}
                            {humanizeNumber(chartData.trueMin, unit)} to{' '}
                            {humanizeNumber(chartData.max, unit)}.{' '}
                            {comparedCouncil || this.isTextBarChart(chartData)
                                ? null
                                : 'Median is the middle value in the selected data range.'}
                            {additionalText && additionalText}
                        </div>
                );
            default:
                return null;
        }
    }

    render() {
        const { data } = this.props;
        return data.map(this.chartMapper);
    }
}

const mapStateToProps = state => ({
    activeCouncil: selectors.getActiveEntity(state),
    councils: selectors.getEntities(state),
    comparedCouncil: selectors.getComparedEntity(state),
});

ChartArea.propTypes = {
    activeCouncil: PropTypes.object.isRequired,
    comparedCouncil: PropTypes.object,
    data: PropTypes.array.isRequired,
    color: PropTypes.string.isRequired,
    unit: PropTypes.string.isRequired,
    visible: PropTypes.bool.isRequired,
};

export default connect(
    mapStateToProps,
    null
)(ChartArea);



// WEBPACK FOOTER //
// ./src/components/data-card-row/chart-area.js